import type { RouteRecordRaw } from 'vue-router'

export const paymentsRoutes: RouteRecordRaw[] = [
  {
    path: '/payments',
    name: 'payments',
    component: () => import('./views/PaymentsView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
  {
    path: '/payments/gateways',
    name: 'payment-gateways',
    component: () => import('./views/PaymentGatewaysView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
  {
    path: '/payments/charge',
    name: 'payment-charge',
    component: () => import('./views/ChargeStudentView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
]
